import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Divider, TextField } from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import { getLabelGrauRelacaoCadaver } from 'helpers/labels'
import useStyles from './FormPessoaReconhecimento.styles'

export const FormPessoaReconhecimento = (props) => {
  const { isReconhecedor, pessoaForm } = props
  const classes = useStyles()

  return (
    <div>
      <Grid className={classes.fieldGroup} container>
        <Grid className={classes.item} item md={4} sm={12} xs={12}>
          <AutocompleteNative
            noOptionsText="Sem informações"
            options={['CPF', 'RG', 'Carteira de trabalho', 'Carteira profissional', 'Passaporte', 'Carteira de identificação funcional', 'Outro']}
            value={pessoaForm.formState.values.tipoDocumento || null}
            onChange={(event, newValue) => {
              pessoaForm.handleChangeNewValueByNameProperty(event, newValue, 'tipoDocumento')
            }}
            getOptionLabel={(option) => option || ''}
            renderOption={(option) => option}
            renderInput={(params) => (
              <TextField
                {...params}
                label="TIPO DO DOCUMENTO APRESENTADO"
                required
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          />
        </Grid>
        <Grid className={classes.item} item md={4} sm={12} xs={12}>
          <TextField
            fullWidth
            label="Nº DO DOCUMENTO"
            name="numeroDocumento"
            required
            minRows={1}
            onChange={pessoaForm.handleChange}
            value={pessoaForm.formState.values.numeroDocumento || ''}
            multiline
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid className={classes.item} item md={4} sm={12} xs={12}>
          <TextField
            fullWidth
            label="ÓRGÃO EMISSOR"
            name="orgaoEmissorDocumento"
            minRows={1}
            required
            onChange={pessoaForm.handleChange}
            value={pessoaForm.formState.values.orgaoEmissorDocumento || ''}
            multiline
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid className={classes.item} item md={8} sm={12} xs={12}>
          <TextField
            fullWidth
            label="NOME"
            name="nome"
            required
            minRows={1}
            onChange={pessoaForm.handleChange}
            value={pessoaForm.formState.values.nome || ''}
            multiline
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid className={classes.item} item md={4} sm={12} xs={12}>
          <TextField
            fullWidth
            required
            label="TELEFONE PARA CONTATO"
            name="telefone"
            minRows={1}
            onChange={pessoaForm.handleChange}
            value={pessoaForm.formState.values.telefone || ''}
            multiline
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        {isReconhecedor && (
          <Grid item md={12} sm={12} xs={12}>
            <Grid className={classes.item} item md={12} sm={12} xs={12}>
              <AutocompleteNative
                name="grauRelacao"
                noOptionsText="Sem informações"
                options={['PARENTE_LINHA_RETA', 'CONJUGE_COMPANHEIRO', 'PARENTE_LINHA_COLATERAL', 'ENTIDADE_LONGA_PERMANENCIA', 'TRABALHO_AMIZADE_VIZINHANCA', 'NENHUMA']}
                value={pessoaForm.formState.values.grauRelacao || null}
                onChange={(event, newValue) => {
                  pessoaForm.handleChangeNewValueByNameProperty(event, newValue, 'grauRelacao')
                }}
                getOptionLabel={(option) => option ? getLabelGrauRelacaoCadaver(option) : ''}
                renderOption={(option) => option ? getLabelGrauRelacaoCadaver(option) : ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="GRAU DE RELAÇÃO DO RECONHECEDOR COM O CADÁVER"
                    required
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        )}
      </Grid>


    </div>
  )
}

FormPessoaReconhecimento.propTypes = {
  isReconhecedor: PropTypes.bool,
  pessoaForm: PropTypes.object.isRequired,
}
